// extracted by mini-css-extract-plugin
module.exports = {"tooltipTrigger":"aprTooltip_tooltipTrigger__2k4ac","tooltipAmount":"aprTooltip_tooltipAmount__12Qkh","tooltipBottom":"aprTooltip_tooltipBottom__2pjjy"};